import { useMemo } from 'react';

import AlertOkModal from '~/common/components/Modals/AlertOkModal';
import {
  LOAN_TAB_LOCK_BY_USER_MESSAGE,
  LOAN_TAB_LOCK_MESSAGE,
} from '~/common/constants/language.json';
import { useLoanLockInformation } from '~/stores/navigationStore';

import { useModalState } from '../modalStore';
import { useLoanTabLock } from './useLoanTabLock';

export default function LoanLockModal() {
  const { isOpen, onClose } = useModalState('loanLock');
  const { loanLockedBy, isLoanCurrentlyLocked } = useLoanLockInformation();
  useLoanTabLock();

  const message = useMemo(() => {
    const isLoanLockedByUser = isLoanCurrentlyLocked && !!loanLockedBy?.trim();

    if (isLoanLockedByUser) {
      return LOAN_TAB_LOCK_BY_USER_MESSAGE.replace(
        '{{lockedByUser}}',
        loanLockedBy,
      );
    }

    return LOAN_TAB_LOCK_MESSAGE;
  }, [loanLockedBy, isLoanCurrentlyLocked]);

  return (
    <AlertOkModal
      isOpen={isOpen}
      handleClose={onClose}
      data={{
        severity: 1,
        title: 'Read-Only Mode',
        description: message,
      }}
    />
  );
}
